import apiClient from "./apiClient";

// ── Sites ─────────────────────────────────────────────────────────────────────
export function fetchSites() {
  return apiClient.get("/api/v1/sites").then((r) => r.data);
}

export function createSite(data) {
  return apiClient.post("/api/v1/sites", data).then((r) => r.data);
}

export function updateSite(id, data) {
  return apiClient.put(`/api/v1/sites/${id}`, data).then((r) => r.data);
}

export function deleteSite(id) {
  return apiClient.delete(`/api/v1/sites/${id}`).then((r) => r.data);
}

export function fetchSiteImpact(siteId) {
  return apiClient.get(`/api/v1/sites/${siteId}/impact`).then((r) => r.data);
}

// ── Rooms ─────────────────────────────────────────────────────────────────────

export function fetchRooms(siteId) {
  const params = siteId ? { siteId } : {};
  return apiClient.get("/api/v1/rooms", { params }).then((r) => r.data);
}

export function fetchRoomsWithSchedule(date) {
  return apiClient.get("/api/v1/rooms", { params: { date } }).then((r) => r.data);
}

export function createRoom(data) {
  return apiClient.post("/api/v1/rooms", data).then((r) => r.data);
}

export function updateRoom(id, data) {
  return apiClient.put(`/api/v1/rooms/${id}`, data).then((r) => r.data);
}

export function deleteRoom(id) {
  return apiClient.delete(`/api/v1/rooms/${id}`).then((r) => r.data);
}

// ── Conflict check ─────────────────────────────────────────────────────────────

export function checkRoomConflicts(roomId, { date, startTime, endTime, excludeSessionId }) {
  const params = { date, startTime, endTime };
  if (excludeSessionId) params.excludeSessionId = excludeSessionId;
  return apiClient.get(`/api/v1/rooms/${roomId}/conflicts`, { params }).then((r) => r.data);
}

export function fetchRoomSessionCount(roomId) {
  return apiClient.get(`/api/v1/rooms/${roomId}/session-count`).then((r) => r.data.count);
}

export function fetchRoomAssignmentCheck(roomId, { classId, date, startTime, endTime, excludeSessionId }) {
  const params = { date, startTime, endTime };
  if (classId != null) params.classId = classId;
  if (excludeSessionId != null) params.excludeSessionId = excludeSessionId;
  return apiClient.get(`/api/v1/rooms/${roomId}/assignment-check`, { params }).then((r) => r.data);
}

// ── Sessions ──────────────────────────────────────────────────────────────────────

export function fetchRoomsWeekRange(from, to) {
  return apiClient.get("/api/v1/rooms", { params: { from, to } }).then((r) => r.data);
}

export function fetchUnassignedSessions(from, to) {
  return apiClient.get("/api/v1/sessions/unassigned", { params: { from, to } }).then((r) => r.data);
}

export function bulkAssignRoom(sessionIds, roomId) {
  return apiClient.patch("/api/v1/sessions/bulk-room", { sessionIds, roomId }).then((r) => r.data);
}

export function patchSessionRoom(sessionId, roomId) {
  return apiClient.patch(`/api/v1/sessions/${sessionId}`, { roomId }).then((r) => r.data);
}

// ── Room features (tenant-configurable equipment list) ─────────────────────────

export function fetchRoomFeatures() {
  return apiClient.get("/api/v1/room-features").then((r) => r.data);
}

export function addRoomFeature(name) {
  return apiClient.post("/api/v1/room-features", { name }).then((r) => r.data);
}

export function deleteRoomFeature(id) {
  return apiClient.delete(`/api/v1/room-features/${id}`).then((r) => r.data);
}
